import { Link } from "react-router-dom";
import { Mail, MapPin, Instagram, Facebook } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="main-footer"
      className="bg-[#1A1A1A] text-[#FAF9F6] mt-32"
    >
      <div className="px-6 md:px-12 lg:px-24 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="md:col-span-4">
            <h3 className="font-serif text-3xl font-light mb-4">
              Challenges Littéraires Éditions
            </h3>
            <p className="text-sm text-[#D1CFC7] font-body leading-relaxed max-w-xs">
              Maison d'édition indépendante dédiée à la découverte de nouvelles
              voix de la littérature francophone.
            </p>
            <div className="flex gap-4 mt-8">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                data-testid="instagram-link"
                className="text-[#D1CFC7] hover:text-[#FAF9F6] transition-colors"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.facebook.com/share/1BbuPaUifd/"
                target="_blank"
                rel="noreferrer"
                data-testid="facebook-link"
                className="text-[#D1CFC7] hover:text-[#FAF9F6] transition-colors"
                aria-label="Page Facebook Pick & Read"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div className="md:col-span-2">
            <p className="text-xs tracking-[0.2em] uppercase text-[#9E4735] font-body mb-5">
              Navigation
            </p>
            <ul className="space-y-3 font-body text-sm">
              <li><Link to="/" className="text-[#D1CFC7] hover:text-[#FAF9F6] transition-colors" data-testid="footer-link-accueil">Accueil</Link></li>
              <li><Link to="/nouveautes" className="text-[#D1CFC7] hover:text-[#FAF9F6] transition-colors" data-testid="footer-link-nouveautes">Nouveautés</Link></li>
              <li><Link to="/livres" className="text-[#D1CFC7] hover:text-[#FAF9F6] transition-colors" data-testid="footer-link-livres">Livres</Link></li>
              <li><Link to="/histoires" className="text-[#D1CFC7] hover:text-[#FAF9F6] transition-colors" data-testid="footer-link-histoires">Histoires offertes</Link></li>
              <li><Link to="/auteurs" className="text-[#D1CFC7] hover:text-[#FAF9F6] transition-colors" data-testid="footer-link-auteurs">Auteurs</Link></li>
              <li><Link to="/gazette" className="text-[#D1CFC7] hover:text-[#FAF9F6] transition-colors" data-testid="footer-link-gazette">Gazette</Link></li>
            </ul>
          </div>

          {/* Légal */}
          <div className="md:col-span-3">
            <p className="text-xs tracking-[0.2em] uppercase text-[#9E4735] font-body mb-5">
              Informations
            </p>
            <ul className="space-y-3 font-body text-sm">
              <li><Link to="/soumission" className="text-[#D1CFC7] hover:text-[#FAF9F6] transition-colors" data-testid="footer-link-soumission">Soumettre un manuscrit</Link></li>
              <li><Link to="/contact" className="text-[#D1CFC7] hover:text-[#FAF9F6] transition-colors" data-testid="footer-link-contact">Nous contacter</Link></li>
              <li><Link to="/mentions-legales" className="text-[#D1CFC7] hover:text-[#FAF9F6] transition-colors" data-testid="footer-link-mentions">Mentions Légales</Link></li>
              <li><Link to="/cgv" className="text-[#D1CFC7] hover:text-[#FAF9F6] transition-colors" data-testid="footer-link-cgv">Conditions Générales de Vente</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-3">
            <p className="text-xs tracking-[0.2em] uppercase text-[#9E4735] font-body mb-5">
              Contact
            </p>
            <ul className="space-y-3 font-body text-sm text-[#D1CFC7]">
              <li className="flex items-start gap-3">
                <Mail size={16} className="mt-0.5 flex-shrink-0" />
                <a href="mailto:challengeslitteraires.editions@gmail.com" className="hover:text-[#FAF9F6] transition-colors break-all" data-testid="footer-email">challengeslitteraires.editions@gmail.com</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 flex-shrink-0" />
                <span>33 avenue Philippe Auguste<br/>75011 Paris, France</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#4A4A4A] flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-xs text-[#757575] font-mono">
            © {new Date().getFullYear()} Challenges Littéraires Éditions. Tous droits réservés.
          </p>
          <p className="text-xs text-[#757575] font-body">
            Conçu avec passion pour les lecteurs.
          </p>
        </div>
      </div>
    </footer>
  );
};
